'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactUtils = require('react-utils');

exports.default = (0, _reactUtils.keyMirror)({
  STAGED: null,
  UNPUBLISHED: null,
  PUBLISHED: null,
  PUBLISH_FAILED: null
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-1.79/js/constants/PubNubMessageStatusTypes.js
// module id = 97
// module chunks = 0 1